export default "__VITE_ASSET__34cfc4de__"